import { render, staticRenderFns } from "./Watchstones.vue?vue&type=template&id=67118268&"
import script from "./Watchstones.vue?vue&type=script&lang=js&"
export * from "./Watchstones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports